import { Expose } from "class-transformer";

export class AddOnCallsToCertificationDto {
  @Expose()
  certificationId: string;

  @Expose()
  onCallIds: string[];
}
